export const AUTH_CONTENT = {
    LOGIN: 'login',
    SIGNUP: 'signup',
}